'use client'

import React, { useImperativeHandle, useState } from "react";
import { useRef } from "react";
import Icon from "./icon";

interface LoginInputInterface extends React.InputHTMLAttributes<HTMLInputElement> { }
const LoginInput = React.forwardRef<HTMLInputElement, LoginInputInterface>(({ onChange, ...rest }, ref) => {
    const inputRef = useRef<HTMLInputElement>(null)
    const [closeShow, setCloseShow] = useState<boolean>(false)

    // 외부 ref에 내부 inputRef 연결
    useImperativeHandle(ref, () => inputRef.current!, []);

    function deleteValue() {
        if (!inputRef.current) return;

        inputRef.current.value = "";
        setCloseShow(false)

        // onChange 이벤트 수동 발생
        const event = new Event("input", { bubbles: true });
        inputRef.current.dispatchEvent(event);
    }

    return (
        <label>
            <input {...rest} ref={inputRef} onChange={e => {
                if (e.currentTarget.value !== "") {
                    setCloseShow(true)
                } else {
                    setCloseShow(false)
                }
                
                // 외부 onChange 실행
                onChange?.(e);
            }} />
            {
                closeShow
                && <span onClick={deleteValue}>
                    <Icon icon={`close`} />
                </span>
            }
        </label>
    )
})

export default LoginInput;